import styled from 'styled-components';

export const FormWrapper = styled.div`
  a {
    color: #fa5245;
    text-decoration: underline;
    font-weight: 700;
  }

  button[disabled] {
    background-color: #b2b2b2;
    color: #d2d2d2;
    border: none;
    &:hover {
      background-color: #b2b2b2;
      color: #d2d2d2;
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
